export enum ResponseState {
  StartResponse = "Start Response",
  ResponseInProgress = "Response In Progress",
  ResponsePendingApproval = "Response Pending Approval",
  ResponseRejected = "Response Rejected",
  ResponseComplete = "Response Complete",
  ResponseCancelled = "Response Cancelled",
}
